import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useLanguage } from "../i18n/LanguageContext";
import { API_URL } from "../data/site";

const inputCls =
  "w-full px-4 py-3 rounded bg-ops-base border border-ops text-sm text-white placeholder:text-ops-muted/50 focus:outline-none focus:border-[#2ea8df] transition-colors font-body";
const labelCls = "block text-[11px] uppercase tracking-widest text-ops-muted mb-1.5 mono-tag";

export const ContactForm = () => {
  const { t } = useLanguage();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
    service: "",
    message: "",
    website: "",
  });

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API_URL}/contact`, {
        ...form,
        service: form.service || t.contact.services[0],
      });
      toast.success(t.contact.success);
      setForm({ name: "", company: "", email: "", phone: "", service: "", message: "", website: "" });
    } catch (err) {
      toast.error(t.contact.error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      data-testid="contact-form"
      onSubmit={onSubmit}
      className="p-8 rounded-2xl border border-ops bg-ops-panel space-y-5"
    >
      {/* honeypot */}
      <input
        type="text"
        value={form.website}
        onChange={set("website")}
        className="hidden"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label htmlFor="cf-name" className={labelCls}>{t.contact.name}</label>
          <input id="cf-name" data-testid="contact-name" type="text" required value={form.name} onChange={set("name")} className={inputCls} />
        </div>
        <div>
          <label htmlFor="cf-company" className={labelCls}>{t.contact.company}</label>
          <input id="cf-company" data-testid="contact-company" type="text" required value={form.company} onChange={set("company")} className={inputCls} />
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label htmlFor="cf-email" className={labelCls}>{t.contact.email}</label>
          <input id="cf-email" data-testid="contact-email" type="email" required value={form.email} onChange={set("email")} className={inputCls} />
        </div>
        <div>
          <label htmlFor="cf-phone" className={labelCls}>{t.contact.phone}</label>
          <input id="cf-phone" data-testid="contact-phone" type="tel" value={form.phone} onChange={set("phone")} className={inputCls} />
        </div>
      </div>

      <div>
        <label htmlFor="cf-service" className={labelCls}>{t.contact.service}</label>
        <select
          id="cf-service"
          data-testid="contact-service"
          value={form.service || t.contact.services[0]}
          onChange={set("service")}
          className={inputCls}
        >
          {t.contact.services.map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
      </div>

      <div>
        <label htmlFor="cf-message" className={labelCls}>{t.contact.message}</label>
        <textarea
          id="cf-message"
          data-testid="contact-message"
          rows={4}
          required
          value={form.message}
          onChange={set("message")}
          className={inputCls}
        />
      </div>

      <button
        type="submit"
        data-testid="contact-submit"
        disabled={loading}
        className="w-full py-4 bg-ops-light text-ops-base font-display font-extrabold text-xs uppercase tracking-[0.2em] rounded hover:bg-white transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
      >
        {loading ? t.contact.sending : t.contact.submit}
      </button>
    </form>
  );
};
